import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useBoolean } from "@/hooks/use-boolean";
import Main from "./main";
import Header from "./header";
import NavVertical from "./nav-vertical";
import { useFullCurrentUser } from "../../hooks/useCurrentUser";
import { useProductFeatures } from "../../hooks/useProductFeatures";
import { useCoursesContent, useAwards } from "../../hooks/useCMSData";
import { useGetEducatorDownloads } from "../../hooks/useGetEducatorDownloads";

import { HatLoading } from "@/components/loading-screen";
import { BannerDisplay } from "@/components/BannerDisplay";
// ----------------------------------------------------------------------

export default function DashboardLayout({ children }) {
  const nav = useBoolean();
  const { userRecordsLoading } = useFullCurrentUser();
  const { isLoading: isProductFeaturesLoading } = useProductFeatures();
  const { loading: isCoursesLoading } = useCoursesContent();
  const { loading: isAwardsLoading } = useAwards();
  const { isLoading: isEducatorDownloadsLoading } = useGetEducatorDownloads();

  // Wait for all essential data to load before showing the layout
  if (
    userRecordsLoading ||
    isProductFeaturesLoading ||
    isCoursesLoading ||
    isAwardsLoading ||
    isEducatorDownloadsLoading
  ) {
    return <HatLoading />;
  }

  const renderNavVertical = (
    <NavVertical openNav={nav.value} onCloseNav={nav.onFalse} />
  );
  return (
    <>
      <Header onOpenNav={nav.onTrue} />

      <Box
        sx={{
          minHeight: 1,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        {renderNavVertical}

        <Main
          sx={{
            px: 0,
          }}
        >
          <BannerDisplay sx={{ mb: 1 }} />
          {children}
        </Main>
      </Box>
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
